import { useRoutes } from "react-router-dom";

import ManagementLayout from "@/components/management/ManagementLayout";
import Dashboard from "@/components/management/Dashboard";
import MenuRoutes from "./routes/MenuRoutes";
import OrderRoutes from "./routes/OrderRoutes";
import ReportRoutes from "./routes/ReportsRoutes";
import LoyaltyRoutes from "./routes/LoyaltyRoutes";
import SettingRoutes from "./routes/SettingRoutes";
import AppointmentRoutes from "./routes/AppointmentRoutes";
import DeviceRoutes from "./routes/DeviceRoutes";
import AddBranch from "@/components/management/components/dashboard/AddBranch";

const routes = [
  {
    path: "/",
    element: <ManagementLayout />,
    children: [
      { path: "", element: <Dashboard /> },
      { path: "dashboard", element: <Dashboard /> },
      { path: "branches/add", element: <AddBranch /> },
      ...MenuRoutes,
      ...OrderRoutes,
      ...ReportRoutes,
      ...DeviceRoutes,
      ...LoyaltyRoutes,
      ...SettingRoutes,
      ...AppointmentRoutes,
    ],
  },
];

const AppRouter = () => useRoutes(routes);

export default AppRouter;
